export * from "modules/CarDetails/components/Tyres/components/DBBLabelsModal";
